/* Aura – monitoraggio Core Web Vitals (LCP, CLS, INP, FCP, TTFB) verso il dataLayer, senza librerie esterne. Debug: aggiungi ?vitals-debug all'URL. */
(function () {
  if (!('PerformanceObserver' in window)) return;
  var dl = window.dataLayer = window.dataLayer || [];
  var limits = { LCP: [2500, 4000], FCP: [1800, 3000], CLS: [0.1, 0.25], INP: [200, 500], TTFB: [800, 1800] };
  var sent = {};
  function rating(n, v) { var t = limits[n]; return v <= t[0] ? 'good' : (v <= t[1] ? 'needs-improvement' : 'poor'); }
  function report(n, v) {
    if (sent[n] || v == null) return;
    sent[n] = true;
    dl.push({ event: 'web_vitals', metric_name: n, metric_value: n === 'CLS' ? Math.round(v * 1000) / 1000 : Math.round(v), metric_rating: rating(n, v), page_type: document.body ? document.body.getAttribute('data-page-type') : '' });
    if (/[?&]vitals-debug/.test(location.search)) console.info('[Aura Web Vitals]', n, v, rating(n, v));
  }
  function observe(type, cb, opts) {
    try {
      var o = { type: type, buffered: true };
      if (opts) for (var k in opts) o[k] = opts[k];
      new PerformanceObserver(function (list) { list.getEntries().forEach(cb); }).observe(o);
    } catch (e) {}
  }
  try { var nav = performance.getEntriesByType('navigation')[0]; if (nav) report('TTFB', nav.responseStart); } catch (e) {}
  observe('paint', function (e) { if (e.name === 'first-contentful-paint') report('FCP', e.startTime); });
  var lcp = 0;
  observe('largest-contentful-paint', function (e) { lcp = e.startTime; });
  var cls = 0, win = 0, winEntries = [];
  observe('layout-shift', function (e) {
    if (e.hadRecentInput) return;
    var first = winEntries[0], last = winEntries[winEntries.length - 1];
    if (win && e.startTime - last.startTime < 1000 && e.startTime - first.startTime < 5000) { win += e.value; winEntries.push(e); }
    else { win = e.value; winEntries = [e]; }
    if (win > cls) cls = win;
  });
  var inp = 0;
  observe('event', function (e) { if (e.interactionId && e.duration > inp) inp = e.duration; }, { durationThreshold: 40 });
  function flush() { if (lcp) report('LCP', lcp); report('CLS', cls); if (inp) report('INP', inp); }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  addEventListener('pagehide', flush);
})();
